import { IAppState } from '../../../AppModulesWrapper';
import { EPublishTermsStatus } from '../../types/reducers/publishTerms';

export function selectPublishTermsStatus(state: IAppState): EPublishTermsStatus {
  const {
    publishTerms: { status },
  } = state.servicePickerWidget;

  return status;
}
